"use client";

import { useSyncExternalStore } from "react";

// `lg` — o mesmo ponto em que a casca troca (trilho ↔ barra de baixo).
const DESKTOP_QUERY = "(min-width: 1024px)";

function subscribe(onChange: () => void) {
  const mq = window.matchMedia(DESKTOP_QUERY);
  mq.addEventListener("change", onChange);
  return () => mq.removeEventListener("change", onChange);
}

/**
 * Computador (a partir de `lg`) ou celular — quem abre popover no computador e
 * folha de baixo no celular (HelpTip, detalhe do KPI). No servidor e na
 * primeira pintura é `false` (celular); a tela certa entra na hidratação.
 */
export function useIsDesktop(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(DESKTOP_QUERY).matches,
    () => false,
  );
}
